// extracted by mini-css-extract-plugin
module.exports = {"tabContainer":"UserProfile_tabContainer_IYoUv"};